import { adjustSponsorTier } from './adjustSponsorTier'
import { adjustPacing } from './adjustPacing'
import { isNumber } from '@/utils/checks'

export const adjustSponsoredCenters = (
  sponsorTier: number,
  budgetPacing: number
) => {
  if (adjustSponsorTier(sponsorTier) && isNumber(budgetPacing)) {
    return adjustSponsorTier(sponsorTier) + adjustPacing(budgetPacing)
  }
  return 0
}
